import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { DECLINE_CANDIDATE, declineCandidate } from '~/actions';
import { ICounterOfferEntity } from '~/domain/Jobs';
import { useIsSuccess, useLoading, useToggle } from '~/hooks';

interface IUseDeclineInterview {
  professionalId: string;
}

export const useDeclineInterview = ({ professionalId }: IUseDeclineInterview) => {
  const dispatch = useDispatch();

  const selectedInterviewIdRef = useRef<string | null>(null);
  const counterOfferRef = useRef<ICounterOfferEntity | null>(null);
  const [isOpen, controls] = useToggle();

  const { isLoading: isDeclineLoading } = useLoading([DECLINE_CANDIDATE]);
  const { isSuccess, clearSuccess } = useIsSuccess([DECLINE_CANDIDATE]);

  const handleDeclineInterview = (interviewId: string, counterOffer: ICounterOfferEntity) => {
    selectedInterviewIdRef.current = interviewId;
    counterOfferRef.current = counterOffer;
    controls.setOn();
  };

  const handleConfirmDeclineInterview = () => {
    if (!selectedInterviewIdRef.current || !counterOfferRef.current) return;
    dispatch(
      declineCandidate({
        jobId: selectedInterviewIdRef.current,
        counterOfferId: counterOfferRef.current.id,
        cancellation_reason: '',
        candidateId: professionalId,
      }),
    );
  };

  const handleCloseDeclineInterview = () => {
    selectedInterviewIdRef.current = null;
    counterOfferRef.current = null;
    controls.setOff();
    clearSuccess();
  };

  return {
    isDeclineSuccess: isSuccess,
    isDeclining: isDeclineLoading,
    isOpen,
    selectedInterviewId: selectedInterviewIdRef.current,
    handleCloseDeclineInterview,
    handleConfirmDeclineInterview,
    handleDeclineInterview,
  };
};
